<div class="header-bar" *ngIf="!checklistAdmin">
  <h1>Driver Checklists</h1>
</div>
<div class="content-container">
  <div [ngClass]="!checklistAdmin ? 'card' : ''">
    <div class="">
      <div class="flex flex-wrap">
        <div class="flex-shrink pb-2">
          <div><strong>Driver Checklist:&nbsp;</strong></div>
        </div>
        <div class="flex-grow-1 pb-2">
          <p-dropdown
            placeholder="Select Checklist"
            [filter]="true"
            [options]="filteredChecklistSelect"
            [style]="{ 'padding-bottom': '10px', 'max-width': '300px', 'min-width': '100px' }"
            [(ngModel)]="selectedChecklistId"
          ></p-dropdown>

          <span
            *ngIf="
              (checklistAdmin || isUserImpersonating) &&
              checklistCategoryName != null &&
              checklistCategoryName.length > 0
            "
            ><span class="category">{{ checklistCategoryName }}</span></span
          >

          <span *ngIf="selectedChecklist" class="department-name">
            <strong>Department:</strong> {{ selectedChecklist.customerDepartmentName }}
            <i
              class="fa fa-pencil-square-o"
              aria-hidden="true"
              (click)="editChecklist()"
              pTooltip="Edit Department"
              *ngIf="!selectedChecklist.locked && !checklistDisabled"
            ></i
          ></span>

          <span class="ml-2">
            <strong>Show disabled checklists: </strong>
            <p-checkbox
              (onChange)="displayDisabledChecklists()"
              id="showDisabledChecklist"
              name="showDisabledChecklist"
              [(ngModel)]="showDisabledChecklists"
              binary="true"
            ></p-checkbox>
          </span>
        </div>

        <div class="flex-shrink-1 pb-2">
          <button
            pButton
            type="button"
            label="Disable"
            class="red-btn pull-right"
            (click)="confirmDeleteChecklist()"
            [disabled]="
              !selectedChecklist ||
              selectedChecklist.locked ||
              selectedChecklist.isDefault ||
              checklistDisabled
            "
            icon="fa fa-times"
          ></button>

          <button
            pButton
            type="button"
            label="Duplicate"
            class="pull-right"
            (click)="checklistNameDialog = true"
            *ngIf="canDuplicate()"
            [disabled]="!selectedChecklist || checklistDisabled"
            icon="fa fa-clone"
          ></button>

          <button
            pButton
            type="button"
            label="Edit"
            class="pull-right"
            (click)="editChecklist()"
            [disabled]="!selectedChecklist || selectedChecklist.locked || checklistDisabled"
            icon="fa fa-pencil"
          ></button>
          <button
            pButton
            type="button"
            label="Add"
            class="green-btn pull-right"
            (click)="newCheckList()"
            icon="fa fa-plus"
          ></button>
          <button
            pButton
            *ngIf="selectedChecklist && !selectedChecklist.isDefault && !checklistDisabled"
            type="button"
            class="checklist group-btn pull-right"
            icon="fa fa-check-circle"
            label="Set Default"
            (click)="setSelectedChecklistAsDefault(false)"
          ></button>

          <span style="line-height: 30px" *ngIf="selectedChecklist && selectedChecklist?.isDefault"
            ><i class="fa fa-check text-success"></i> Default Checklist &nbsp;</span
          >
        </div>
      </div>

      <span *ngFor="let orgStepSubCat of this.selectedChecklist?.orgStepChecklistSubCategories">
        <div
          class="sample-title"
          [ngStyle]="{
            'outline-color': orgStepSubCat?.checklistSubCategory?.checklistCategory?.rgb
          }"
          style="margin-bottom: 7px"
        >
          <div
            class="sample-category"
            [ngStyle]="{
              'background-color': orgStepSubCat?.checklistSubCategory?.checklistCategory?.rgb
            }"
          >
            {{ orgStepSubCat.checklistSubCategory.checklistCategory.title }}
          </div>
          <div
            class="sample-subcategory"
            [ngStyle]="{ color: orgStepSubCat?.checklistSubCategory?.checklistCategory?.rgb }"
          >
            {{ orgStepSubCat.checklistSubCategory.title }}
          </div>
        </div>
        &nbsp;
      </span>

      <button
        pButton
        *ngIf="this.selectedChecklist?.infoURL"
        (click)="visitURL(this.selectedChecklist.infoURL)"
        class="ui-button-secondary workflow-button"
        label="Workflow"
        icon="fa fa-external-link"
      ></button>

      <div *ngIf="this.selectedChecklist" class="mt-2">
        <div class="grid">
          <div class="col-12 md:col-6">
            <div class="greybox">
              Customer Description: {{ this.selectedChecklist.customerDescription }}
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div class="greybox">
              Supplier Description: {{ this.selectedChecklist.supplierDescription }}
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div class="greybox">
              Customer Disclaimer: {{ this.selectedChecklist.customerDisclaimer }}
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="selectedChecklist">
        <div *ngIf="selectedChecklist != null && selectedChecklist.locked" class="checklist-locked">
          <table class="width-100">
            <tr>
              <td>
                <h3 style="display: inline-block; margin-top: 5px; margin-bottom: 5px">
                  Checklist Locked
                </h3>
              </td>
              <td style="text-align: right">
                <div style="padding-top: 5px">
                  <button pButton style="padding-top: 5px" (click)="unlockChecklist()">
                    <i class="fa fa-lock" style="display: inline-block; vertical-align: middle"></i>
                    <span style="display: inline-block; vertical-align: middle">&nbsp;Unlock</span>
                  </button>
                </div>
              </td>
            </tr>
          </table>

          <div class="small-print">
            This is a standard checklist created by Engineius. Changes made by Engineius to this
            checklist will automatically be reflected here. Unlock this checklist to create a custom
            Checklist, subsequent changes to the Engineius checklist will not be reflected here.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-tabView *ngIf="this.selectedChecklist != null" class="tab-padding no-widget-border">
  <p-tabPanel header="Custom Steps" [selected]="true">
    <div class="ui-g card">
      <div class="ui-g-6 ui-sm-12">
        <div class="ui-g">
          <div class="ui-g-6">
            <h2 class="sub-header-bar mt-1">Pick-up Steps:</h2>
            <div></div>
          </div>
          <div class="ui-g-6 text-right">
            <button
              type="button"
              pButton
              icon="fa ui-icon-add"
              (click)="addNewStep(true)"
              label="Add"
              [disabled]="!selectedChecklist || selectedChecklist.locked || checklistDisabled"
            ></button>
          </div>
        </div>
        <div class="dashboard margin-right">
          <div class="task-list task">
            <p-table [value]="pickupSteps">
              <ng-template pTemplate="body" let-rowData let-index="rowIndex">
                <tr
                  [pReorderableRow]="index"
                  (dragend)="stepOrderChanged(true)"
                  (click)="selectedPickupStepId = rowData?.id"
                  class="navigation step-detail checklist-item"
                  [class.selected-row]="rowData?.id == selectedPickupStepId"
                >
                  <td class="shrink-cell">
                    <i
                      class="fa fa-edit link-pointer"
                      (click)="editChecklistItem(rowData)"
                      *ngIf="!checklistDisabled"
                    ></i>
                  </td>
                  <td>
                    {{ rowData.name }}
                  </td>
                  <td
                    class="text-center shrink-cell"
                    *ngIf="!selectedChecklist.locked && !checklistDisabled"
                  >
                    <i class="fa fa-trash link-pointer" (click)="deleteStep(rowData.id, true)"></i>
                  </td>
                  <td
                    class="text-center shrink-cell"
                    *ngIf="!selectedChecklist.locked && !checklistDisabled"
                  >
                    <i class="fa fa-bars link-grab" [pReorderableRowHandle]="index"></i>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>

      <!-- SPECIFIC STEPS -->
      <div class="ui-g-6 ui-sm-12">
        <div class="ui-g">
          <div class="ui-g-6">
            <h2 class="sub-header-bar mt-1">Drop-off Steps:</h2>
          </div>
          <div class="ui-g-6 text-right">
            <button
              type="button"
              pButton
              icon="fa ui-icon-add"
              (click)="addNewStep(false)"
              label="Add"
              [disabled]="!selectedChecklist || selectedChecklist.locked || checklistDisabled"
            ></button>
          </div>
        </div>
        <div class="dashboard margin-right">
          <div class="task-list task">
            <div *ngIf="dropoffSteps && dropoffSteps.length == 0">
              <div class="text-center">
                <h3>No Checklist items</h3>
              </div>
            </div>

            <p-table [value]="dropoffSteps">
              <ng-template pTemplate="body" let-rowData let-index="rowIndex">
                <tr
                  [pReorderableRow]="index"
                  (dragend)="stepOrderChanged(false)"
                  (click)="selectedDropoffStepId = rowData?.id"
                  class="navigation step-detail checklist-item"
                  [class.selected-row]="rowData?.id == selectedDropoffStepId"
                >
                  <td class="shrink-cell">
                    <i
                      class="fa fa-edit link-pointer"
                      (click)="editChecklistItem(rowData)"
                      *ngIf="!checklistDisabled"
                    ></i>
                  </td>
                  <td>
                    {{ rowData.name }}
                  </td>
                  <td
                    class="text-center shrink-cell"
                    *ngIf="!selectedChecklist.locked && !checklistDisabled"
                  >
                    <i class="fa fa-trash link-pointer" (click)="deleteStep(rowData.id, false)"></i>
                  </td>
                  <td
                    class="text-center shrink-cell"
                    *ngIf="!selectedChecklist.locked && !checklistDisabled"
                  >
                    <i class="fa fa-bars link-grab" [pReorderableRowHandle]="index"></i>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
        <div class="footer" *ngIf="isBusy">
          <img
            src="assets/images/loader.gif"
            alt="loader"
            class="footer-img"
            style="width: 50px; height: 50px"
          />
        </div>
      </div>
    </div>
  </p-tabPanel>
  <p-tabPanel header="Task Types">
    <!--todo: both of these need that observable logic removing.-->
    <app-organisation-specific-step-task-types
      [selectedChecklist]="selectedChecklist"
    ></app-organisation-specific-step-task-types>
  </p-tabPanel>
  <p-tabPanel header="Customers" *ngIf="checklistAdmin">
    <app-organisation-specific-step-customers
      [selectedChecklistEvent]="selectedChecklist$"
      [stepListChangedEvent]="stepListAltered.asObservable()"
    >
    </app-organisation-specific-step-customers>
  </p-tabPanel>
</p-tabView>

<p-dialog
  header="Checklist"
  [(visible)]="editChecklistDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '600px' }"
>
  <form [formGroup]="checklistForm" autocomplete="off" *ngIf="checklistForm">
    <div class="ui-grid ui-grid-responsive ui-fluid">
      <div class="ui-g-12 pb-2">
        <div class="mb-2"><strong>Group Name:</strong></div>
        <input
          pInputText
          name="groupName"
          formControlName="groupName"
          maxlength="250"
          placeholder="Name"
        />
        <div class="text-danger" *ngIf="checklistNameExists()">
          Group name already in use. Select another
        </div>
      </div>

      <div class="ui-g-12 pb-2" *ngIf="checklistAdmin || isUserImpersonating">
        <div class="mb-2"><strong>Checklist Categories:</strong></div>
        <p-multiSelect
          [options]="checklistSubCategorySelect"
          formControlName="checklistSubCategoryIds"
          id="checklistSubCategories"
          appendTo="body"
          [style]="{ 'padding-bottom': '10px' }"
          defaultLabel="Checklist Categories"
          styleClass="checklist-categories"
        >
        </p-multiSelect>
      </div>

      <div class="ui-g-12 pb-2" *ngIf="checklistAdmin || isUserImpersonating">
        <div class="mb-2">
          <strong>Department</strong>
          <span style="color: #888; font-size: 12px" class="ml-2" *ngIf="editingChecklistIsDefault"
            >(You are unable to edit the department against the default checklist)</span
          >
        </div>
        <p-dropdown
          [options]="departmentSelect"
          formControlName="customerDepartmentId"
          appendTo="body"
          [style]="{ 'padding-bottom': '10px', 'max-width': '100%' }"
          placeholder="Global"
          [disabled]="editingChecklistIsDefault"
        ></p-dropdown>
      </div>

      <div class="ui-g-12">
        <div class="mb-2">
          <strong>Workflow URL: </strong>
          <span style="color: #888; font-size: 12px">(http prefix required)</span>
        </div>
        <div><input pInputText formControlName="infoURL" placeholder="Workflow URL" /></div>
      </div>

      <div class="ui-g-6">
        <div class="mb-2"><strong>Customer Description:</strong></div>
        <textarea
          pInputTextarea
          autoResize="autoResize"
          [rows]="3"
          [cols]="30"
          name="customerDescription"
          formControlName="customerDescription"
          maxlength="250"
        ></textarea>
      </div>
      <div class="ui-g-6">
        <div class="mb-2"><strong>Supplier Description:</strong></div>
        <textarea
          pInputTextarea
          autoResize="autoResize"
          [rows]="3"
          [cols]="30"
          name="supplierDescription"
          formControlName="supplierDescription"
          maxlength="250"
        ></textarea>
      </div>
      <div class="ui-g-6">
        <div class="mb-2"><strong>Customer Disclaimer:</strong></div>
        <textarea
          pInputTextarea
          autoResize="autoResize"
          [rows]="3"
          [cols]="30"
          name="customerDisclaimer"
          formControlName="customerDisclaimer"
          maxlength="250"
        ></textarea>
      </div>
      <input type="hidden" name="id" formControlName="id" />
    </div>
    <br />
  </form>
  <p-footer>
    <button
      type="button"
      pButton
      icon="fa fa-times"
      label="Cancel"
      (click)="editChecklistDialog = false"
    ></button>
    <button
      type="submit"
      class="green-btn"
      pButton
      label="Save"
      icon="fa fa-check"
      [disabled]="!formChecklistName || checklistNameExists() || checklistForm.invalid"
      (click)="
        checklistForm.controls.id?.value
          ? saveChecklist(checklistForm.value)
          : addChecklist(checklistForm.value)
      "
    ></button>
  </p-footer>
</p-dialog>
<p-dialog
  [header]="
    (selectedStep?.id ? 'Edit' : 'Add') + ' Checklist Item for ' + selectedChecklist?.groupName
  "
  [(visible)]="editStepDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '800px' }"
  [contentStyle]="{ 'max-height': '700px', overflow: 'auto' }"
>
  <app-add-organisation-specific-step
    [selectedChecklistEvent]="selectedChecklist$"
    [organisationSpecificStep]="selectedStep"
    (closeDialog)="handleCloseDialog($event)"
    (checklistStepUpdated)="handleChecklistStepUpdated()"
  ></app-add-organisation-specific-step>
</p-dialog>

<p-dialog
  header="Duplicate Checklist"
  [style]="{ width: '500px' }"
  [(visible)]="checklistNameDialog"
  [modal]="true"
>
  <div>
    Checklist Name:
    <input
      pInputText
      [(ngModel)]="newChecklistName"
      placeholder="Checklist name"
      style="width: 300px"
    />
  </div>
  <div class="text-right" style="padding-top: 20px">
    <button type="button" pButton (click)="checklistNameDialog = false" class="duplicate-buttons">
      <i class="fa fa-times"></i> Cancel
    </button>
    <button
      type="submit"
      class="green-btn duplicate-buttons"
      pButton
      [disabled]="!newChecklistName || isBusy"
      style
      (click)="duplicateChecklist()"
    >
      <span *ngIf="!isBusy"><i class="fa fa-check"></i> Save</span>
      <span *ngIf="isBusy"><i class="fa fa-spin fa-spinner"></i> Wait</span>
    </button>
  </div>
</p-dialog>

<p-confirmDialog
  header="Confirmation"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Yes"
  rejectLabel="No"
></p-confirmDialog>
